export default function AttachStatementFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  ecatDataService,
  docDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isExpanded = false;
  vm.loaded = false;
  vm.loading = false;

  // Attach Event Handlers
  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleAttachFolder = _handleAttachFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFolder();
    }
  }

  function _refreshFolder() {
    vm.loaded = false;
    loaderService.showViewLoader = true;

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        vm.loaded = true;
        loaderService.showViewLoader = false;
      });
    });
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      ecatDataService.getCRIStatementDocumentsByFolder(vm.assessmentId, vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId && assignedDoc.CRIStatementId === vm.criStatementId) {
                childDoc.CRIStatementDocumentId = assignedDoc.CRIStatementDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      ecatDataService.getCRIStatementFoldersByFolder(vm.assessmentId, vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId && assignedFolder.CRIStatementId === vm.criStatementId) {
                childFolder.CRIStatementFolderId = assignedFolder.CRIStatementFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _handleAttachFolder() {
    const dfdSave = $q.defer();

    if (vm.folder.attached) {
      ecatDataService.attachCRIStatementFolder(vm.assessmentId, vm.criStatementId, vm.folder.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been attached successfully.`);
          vm.folder.CRIStatementFolderId = response.data.CRIStatementFolderId;
          $rootScope.$broadcast('refreshCRIStatementFolders', { criStatementId: vm.criStatementId });
          $rootScope.$broadcast('refreshCRIStatementDocuments', { criStatementId: vm.criStatementId });
          dfdSave.resolve();
        }
      });
    } else {
      ecatDataService.detachCRIStatementFolder(vm.folder.CRIStatementFolderId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while detaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been detached successfully.`);
          vm.folder.findingFolderId = null;
          $rootScope.$broadcast('refreshCRIStatementFolders', { criStatementId: vm.criStatementId });
          $rootScope.$broadcast('refreshCRIStatementDocuments', { criStatementId: vm.criStatementId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachStatementFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'ecatDataService',
  'docDataService'
];
